import { validationFormStepZero } from './validations/stepZero';
import { validationFormStepOne } from './validations/stepOne';
import { validationFormStepTwo } from './validations/stepTwo';
import { validationFormStepThree } from './validations/stepThree';

export const validationsArray = [
	validationFormStepZero,
	validationFormStepOne,
	validationFormStepTwo,
	validationFormStepThree,
];
